export class PitrBackupResourceType {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceType",
            "baseName": "resourceType",
            "type": "ResourceType & string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return PitrBackupResourceType.attributeTypeMap;
    }
    constructor() {
    }
}
